"use strict";

var _slicedToArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Validator = void 0;

var jsonschema_1 = require("jsonschema");

var versions_1 = require("./versions");

var Validator = /*#__PURE__*/function () {
  function Validator(version) {
    _classCallCheck(this, Validator);

    // require version <name>-<calver>
    versions_1.validateVersion(version);

    var _version$split = version.split('-'),
        _version$split2 = _slicedToArray(_version$split, 2),
        name = _version$split2[0],
        calVer = _version$split2[1];

    this.name = name;
    this.calVer = calVer;
  }
  /**
   * Validates the passed json against the Validator's schema
   *
   * @param json
   */


  _createClass(Validator, [{
    key: "validate",
    value: function validate(json) {
      var jsonValidator = new jsonschema_1.Validator();

      var schema = require("../schemas/".concat(this.name, "/").concat(this.calVer, ".json"));

      return jsonValidator.validate(json, schema).valid;
    }
  }]);

  return Validator;
}();

exports.Validator = Validator;